// extracted by mini-css-extract-plugin
export default {"logoutButton":"DriverLogout_logoutButton__StMy0","logoutText":"DriverLogout_logoutText__4qbdI"};